( function () {
   
    'use strict';

    ( function ( $ ) {
        
        
        $('.buytickets-faqs-detail .faq-item-main').click(function(){
          if ($(this).parent(".faq-item").hasClass("active")) {
            $(this).parent(".faq-item").removeClass("active");
            $(this).siblings(".faq-item-content").slideUp(500);
          } else {
            $(".faq-item").removeClass("active");
            $(".faq-item .faq-item-content").slideUp(500);
            $(this).parent(".faq-item").addClass("active");
            $(this).siblings(".faq-item-content").slideDown(500);
          }
        })

       
    } )( jQuery );
} )();

